import React from 'react';
import { Grid } from '@mui/material';

import { HorizontalBarChar } from './HorizontalBarChar';

import "./loadingAnimation.css"

export const UnitsGraphs = (props) => {

  return (
    <Grid container fullWidth spacing={1}>
      <Grid item xs={12}>
        <HorizontalBarChar saveHandlers={props} />
      </Grid>
    </Grid>
  )
}
